<template>
  <div>
    <QS-h4-title title="运营情况"/>
    <template v-if="(state === 4500 && !isDisabled)">
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">运营流水: </div>
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <el-input class="box-val" v-model="operation.amount" placeholder="请输入" @input="(val) => moneyBlur(val)">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="box-content">
          <div class="box-label">备注: </div>
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <el-input class="box-val box-textarea" v-model="operation.remark" type="textarea" placeholder="请输入备注"
            maxlength="500" show-word-limit>
          </el-input>
        </div>
      </div>
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">备注图片: </div>
          <div class="box-upload ml16">
            <UploadCommon
              :fileList="operation.photos"
              :isAlone="false"
              :isShowTitle="false"
              :limit="3"
              :showUploadBtnByLimit="3"
              :sizeType="4"
              commonUpload
              group="order"
              code="order_vehicle_note_pic"
            >
            </UploadCommon>
          </div>
        </div>
      </div>
    </template>
    <template v-if="(state === 5500 || isDisabled)">
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">运营流水: </div>
          <div class="box-val">{{ operation.amount || '0.00' }}元</div>
        </div>
        <div class="box-content">
          <div class="box-label">备注: </div>
          <div class="box-val">{{ operation.remark || '--' }}</div>
        </div>
      </div>
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">备注图片: </div>
          <div class="box-photos" v-if="operation.photos.length">
            <div class="item" v-for="(item, index) in operation.photos" :key="index">
              <EnlargeImg :imgSrc="item.url" />
            </div>
          </div>
          <div v-else>--</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { limitMoreZero } from '@/utils/validate'

export default {
  props: {
    state: {
      type: [Number, String],
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    operation: {
      type: Object,
      default: () => { },
    },
  },
  methods: {
    moneyBlur(value) {
      const self = this
      limitMoreZero(value, (res) => {
        // eslint-disable-next-line vue/no-mutating-props
        self.operation.amount = res
      }, 7)
    },
  },
}
</script>
<style lang="scss" scoped>
.box-container {
  display: flex;
}

.box-content {
  display: flex;
  margin-bottom: 16px;

  .box-label {
    width: 150px;
    flex: 0 0 auto;
    padding-right: 10px;
    color: #333333;
    text-align: right;
  }

  .box-val {
    display: flex;
    min-width: 200px;
    word-break: break-all;
    ::v-deep .el-input-group__append {
      line-height: 32px;
      height: 32px;
      width: auto;
      padding: 0 10px;
    }
  }

  .box-textarea {
    width: 300px
  }

  .box-photos {
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-left: 16px;
      width: 80px;
      height: 80px;

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 30px;
      }
    }
  }
}
</style>
